<div #imageViewContainer>
  @if (imageView() === ImageView.SINGLE) {
    <div class="single ion-activatable ripple-parent">
      <ion-icon name="open-outline" />
      <img
        [src]="url(images()[0])"
        (click)="presentImageModal(images()[0])"
        alt="Afbeelding welke nodig is om de vraag te beantwoorden"
      />
      <ion-ripple-effect />
    </div>
  } @else {
    <swiper-container #swiper init="false">
      @for (image of images(); track image) {
        <swiper-slide>
          <ion-icon name="open-outline" />
          <img
            [src]="url(image)"
            (click)="presentImageModal(image)"
            alt="Afbeelding welke nodig is om de vraag te beantwoorden"
          />
          <ion-ripple-effect />
        </swiper-slide>
      }
    </swiper-container>
    <div class="swiper-navigation">
      <div class="button-prev">
        <ion-icon slot="icon-only" name="chevron-back-outline" />
        <ion-ripple-effect />
      </div>
      <div class="button-next">
        <ion-icon slot="icon-only" name="chevron-forward-outline" />
        <ion-ripple-effect />
      </div>
    </div>
  }
</div>
